import { CRUD } from "@/shared/components";
import { AssistantUsagesListQuery } from "@/admin/entities/assistant";
import {
  useAssistantUsageManagement,
  type AssistantUsageRow,
  AssistantUsageSchemas,
} from "../model";

/**
 * Месячный расход арен на помощника. Только просмотр: записи создаются
 * бэкендом (AssistantUsageRepository.addUsage), редактирования нет.
 */
export function AssistantUsage() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useAssistantUsageManagement();

  return (
    <CRUD<AssistantUsageRow>
      listQuery={AssistantUsagesListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={AssistantUsageSchemas.filterSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
